/**
 * Parses press/blog URLs in the new format: /info-center/{type}/{slug}~{pageId}
 * Also supports backward compatibility with old format: /info-center/{type}~{name}~s={id}~
 */
export function parsePressBlogUrl(
  pathname: string
): {
  type: "press" | "blog" | null;
  slug: string | null;
  pageId: string | null;
} {
  // New format: /info-center/{type}/{slug}~{pageId}
  const newFormatMatch = pathname.match(
    /\/info-center\/(press|blog)\/([^~]+)~([^~]+)$/
  );
  if (newFormatMatch) {
    return {
      type: newFormatMatch[1] as "press" | "blog",
      slug: newFormatMatch[2],
      pageId: newFormatMatch[3],
    };
  }

  // Old format (backward compatibility): /info-center/{type}~{name}~s={id}~
  const oldFormatMatch = pathname.match(
    /\/info-center\/(press|blog)~([^~]+)~s=([^~]+)~/
  );
  if (oldFormatMatch) {
    return {
      type: oldFormatMatch[1] as "press" | "blog",
      slug: oldFormatMatch[2],
      pageId: oldFormatMatch[3],
    };
  }

  return { type: null, slug: null, pageId: null };
}

/**
 * Generates a press/blog URL in the new format: /info-center/{type}/{slug}~{pageId}
 */
export function generatePressBlogUrl(
  type: "press" | "blog",
  slug: string,
  pageId: string,
  language: string,
  multisiteBase?: string
): string {
  const basePath = multisiteBase
    ? `/${multisiteBase}/${language}/info-center/${type}/${slug}~${pageId}`
    : `/${language}/info-center/${type}/${slug}~${pageId}`;

  return basePath;
}

/**
 * Checks if a pathname is a press/blog URL (new or old format)
 */
export function isPressBlogUrl(pathname: string): boolean {
  return (
    /\/info-center\/(press|blog)\//.test(pathname) ||
    /\/info-center\/(press|blog)~/.test(pathname)
  );
}

